/* Conscomer — Selector de aislamiento */
(function () {
  'use strict';

  if (window.conscomerSelectorLoaded) return;
  window.conscomerSelectorLoaded = true;

  var NS = 'http://www.w3.org/2000/svg';

  /* ------------------------------------------------------------------
     Iconos SVG lineales (sin librerías externas, sin emojis)
     ------------------------------------------------------------------ */

  var ICON_PATHS = {
    tuberia: ['M3 9.5h18v5H3z', 'M7 9.5V6.5M7 17.5v-3M17 9.5V6.5M17 17.5v-3'],
    horno: ['M3.5 4.5h17v15h-17z', 'M3.5 9.5h17', 'M8 13.5h8', 'M8 16.5h5'],
    frio: ['M12 3v18', 'M4.2 7.5l15.6 9', 'M19.8 7.5L4.2 16.5', 'M12 7.5L9.5 5.5M12 7.5l2.5-2M12 16.5L9.5 18.5M12 16.5l2.5 2'],
    construccion: ['M2.5 20.5h19', 'M5 20.5V9h6v11.5', 'M13 20.5V3.5h6v17', 'M7 12.5h2M7 16h2M15 7h2M15 11h2M15 15h2'],
    alimento: ['M9 3.5h6', 'M10 3.5v6L5.1 18a1.8 1.8 0 0 0 1.6 2.7h10.6a1.8 1.8 0 0 0 1.6-2.7L14 9.5v-6', 'M7.4 15.5h9.2'],
    acustico: ['M3 11v2', 'M7.5 7.5v9', 'M12 3.5v17', 'M16.5 6.5v11', 'M21 10v4'],
    fuego: ['M12 2.5c3.2 3.8 5.8 6.2 5.8 10a5.8 5.8 0 0 1-11.6 0c0-2.3 1.2-3.9 2.6-5.3', 'M12 20.3a3 3 0 0 0 3-3c0-1.6-1.6-2.6-3-4.6-1.4 2-3 3-3 4.6a3 3 0 0 0 3 3z'],
    'temp-frio': ['M14 14.6V5.5a2 2 0 1 0-4 0v9.1a4 4 0 1 0 4 0z', 'M12 14V11.5'],
    'temp-medio': ['M14 14.6V5.5a2 2 0 1 0-4 0v9.1a4 4 0 1 0 4 0z', 'M12 14V9.5'],
    'temp-alto': ['M14 14.6V5.5a2 2 0 1 0-4 0v9.1a4 4 0 1 0 4 0z', 'M12 14V7.5'],
    'temp-muy-alto': ['M14 14.6V5.5a2 2 0 1 0-4 0v9.1a4 4 0 1 0 4 0z', 'M12 14V6', 'M17.5 5.5h4M17.5 9h3'],
    check: ['M4 12.5l5 5 11-11']
  };

  function buildIcon(name) {
    var paths = ICON_PATHS[name];
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.5');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    if (!paths) return svg;
    for (var i = 0; i < paths.length; i++) {
      var p = document.createElementNS(NS, 'path');
      p.setAttribute('d', paths[i]);
      svg.appendChild(p);
    }
    return svg;
  }

  /* ------------------------------------------------------------------
     Preguntas
     ------------------------------------------------------------------ */

  var TREE = [
    {
      id: 'aplicacion',
      resumen: 'Aplicación',
      pregunta: '¿Cuál es la aplicación principal?',
      opciones: [
        { icon: 'tuberia',      label: 'Tuberías industriales',   sub: 'Vapor, agua, líneas de proceso',   val: 'tuberia' },
        { icon: 'horno',        label: 'Hornos y calderas',       sub: 'Equipos de alta temperatura',      val: 'horno' },
        { icon: 'frio',         label: 'Refrigeración y HVAC',    sub: 'Frío y climatización',             val: 'frio' },
        { icon: 'construccion', label: 'Construcción y ductos',   sub: 'Paredes, techos y ductos',         val: 'construccion' },
        { icon: 'alimento',     label: 'Alimentos y farmacéutica', sub: 'Inocuidad y contacto seguro',     val: 'alimento' },
        { icon: 'acustico',     label: 'Acústico y vibración',    sub: 'Reducción de ruido y vibración',   val: 'acustico' },
        { icon: 'fuego',        label: 'Protección contra fuego', sub: 'Resistencia al fuego',             val: 'fuego' }
      ]
    },
    {
      id: 'temperatura',
      resumen: 'Temperatura',
      pregunta: '¿A qué temperatura opera el sistema?',
      compacto: true,
      opciones: [
        { icon: 'temp-frio',     label: 'Frío',      sub: '−20 °C a 20 °C',    val: 'frio' },
        { icon: 'temp-medio',    label: 'Moderado',  sub: '20 °C a 200 °C',    val: 'medio' },
        { icon: 'temp-alto',     label: 'Alto',      sub: '200 °C a 650 °C',   val: 'alto' },
        { icon: 'temp-muy-alto', label: 'Muy alto',  sub: 'Más de 650 °C',     val: 'muy-alto' }
      ]
    }
  ];

  /* ------------------------------------------------------------------
     Recomendaciones
     ------------------------------------------------------------------ */

  var RECS = {

    /* ── TUBERÍAS ── */
    'tuberia-frio': {
      best: { nombre: 'K-FLEX® INSUL-TUBO', url: '/collections/elastomero-aislamiento-tuberias-armaflex',
        razon: 'Espuma elastomérica de célula cerrada NBR/PVC. Rango -183 °C a +104 °C, retardador de vapor Clase 1 (ASHRAE), certificación UL GREENGUARD® Gold. Previene condensación en tuberías frías (ASTM C534).' },
      alts: ['Poliisocianurato ISO-C1 (hasta -183 °C, criogénico)']
    },
    'tuberia-medio': {
      best: { nombre: 'Preformado de Lana Mineral', url: '/collections/lana-mineral',
        razon: 'Fabricado para NPS estándar. Rango -29 °C a 649 °C, ASTM C547 Tipo I/II/IV Grado A, NOM-009-ENER-2014. Incombustible (ASTM E136), resistente al moho (ASTM C1338), no corrosivo.' },
      alts: ['Colcha de Lana Mineral 144 kg/m³']
    },
    'tuberia-alto': {
      best: { nombre: 'Preformado de Lana Mineral', url: '/collections/lana-mineral',
        razon: 'Temperatura máxima 649 °C (1200 °F), contracción lineal <1 % (ASTM C356), aprueba ASTM C411. Solución estándar para tuberías de proceso de alta temperatura industrial.' },
      alts: ['Colcha de Lana Mineral 144 kg/m³ (hasta 750 °C)']
    },
    'tuberia-muy-alto': {
      best: { nombre: 'Fibra Cerámica HTZ 1400', url: '/collections/fibra-ceramica-hornos',
        razon: 'Uso continuo hasta 1325 °C, límite máximo 1425 °C (2600 °F). Sin aglutinante, sin amianto, sin tiempo de curado. Resistente al choque térmico. La única opción para tuberías a más de 650 °C.' },
      alts: ['Fibra Cerámica HPS 1200 (uso continuo hasta 1200 °C)']
    },

    /* ── HORNOS Y CALDERAS ── */
    'horno-frio': {
      best: { nombre: 'K-FLEX® Rollo Elastómero', url: '/collections/elastomero-k-flex',
        razon: 'Lámina elastomérica flexible -40 °C a +93 °C. Autoextinguible (ASTM D635), sin polvo, fácil instalación en equipos, tanques y ductos a baja temperatura. UL GREENGUARD® Gold.' },
      alts: ['Poliisocianurato ISO-C1']
    },
    'horno-medio': {
      best: { nombre: 'Colcha de Lana Mineral 144 kg/m³', url: '/collections/lana-mineral',
        razon: 'Temperatura de uso hasta 750 °C. Densidad 144 kg/m³ (EN1602), cumple ASTM C592 Type I & III y NRF-034-PEMEX. Sin asbesto, sin bacterias ni moho (ASTM C1338), corrosión nula.' },
      alts: ['Preformado de Lana Mineral']
    },
    'horno-alto': {
      best: { nombre: 'Colcha de Lana Mineral 144 kg/m³', url: '/collections/lana-mineral',
        razon: 'Hasta 750 °C, contracción 3.5 % (ASTM C356), corrosión nula (ASTM C692/C795). Cumple NRF-034-PEMEX para aislamientos térmicos de alta temperatura en calderas y hornos industriales.' },
      alts: ['Fibra Cerámica HPS 1200']
    },
    'horno-muy-alto': {
      best: { nombre: 'Fibra Cerámica HTZ 1400', url: '/collections/fibra-ceramica-hornos',
        razon: 'Límite máximo 1425 °C (2600 °F). Análisis: ZrO₂ 99 %, alta pureza refractaria. Sin tiempo de curado, resistente al choque térmico. Para hornos de fundición, calderas de alta presión y reactores.' },
      alts: ['Fibra Cerámica HPS 1200 (hasta 1315 °C continuo)']
    },

    /* ── REFRIGERACIÓN / HVAC ── */
    'frio-frio': {
      best: { nombre: 'K-FLEX® INSUL-TUBO', url: '/collections/elastomero-aislamiento-tuberias-armaflex',
        razon: 'Célula cerrada, absorción de agua 0 % (ASTM C209), permeabilidad al vapor <0.01 perm-in. Clasif. ASTM E84 25/50, cumple NFPA 90A/B. Agente antimicrobiano EPA integrado. Ideal para refrigerante y agua fría.' },
      alts: ['Poliisocianurato ISO-C1 (hasta -183 °C, criogénico)']
    },
    'frio-medio': {
      best: { nombre: 'K-FLEX® Rollo Elastómero', url: '/collections/elastomero-k-flex',
        razon: 'Lámina para ductos y equipos de climatización. R-8 a 2 pulgadas, cumple IECC para ductos al aire libre. Autoextinguible, sin olores (ASTM C1304), UL GREENGUARD® Gold.' },
      alts: ['Metal Building Insulation MBI (fibra de vidrio laminada)']
    },
    'frio-alto': {
      best: { nombre: 'FireMaster® FastWrap® XL', url: '/collections/telas-aislamiento-reusable',
        razon: 'Manta hasta 1200 °C encapsulada en lámina de aluminio reforzada. Listada UL/ULC para ductos HVAC 1, 2 y 3 horas (ISO 6944). Cumple NFPA 96, IMC, CMC. Resistencia al moho validada por UL.' },
      alts: ['Colcha de Lana Mineral 144 kg/m³ (hasta 750 °C)']
    },
    'frio-muy-alto': {
      best: { nombre: 'Fibra Cerámica HPS 1200', url: '/collections/fibra-ceramica-hornos',
        razon: 'Para sistemas HVAC industriales de altísima temperatura. Uso continuo hasta 1200 °C, baja conductividad térmica, resistencia al choque térmico. Aplicaciones en refinación y petroquímica.' },
      alts: ['Fibra Cerámica HTZ 1400']
    },

    /* ── CONSTRUCCIÓN / DUCTOS ── */
    'construccion-frio': {
      best: { nombre: 'Metal Building Insulation (MBI)', url: '/collections/fibra-de-vidrio',
        razon: 'Fibra de vidrio laminada con barrera de vapor. R-10 a R-30, cumple ASTM C991 y NAIMA 202-96. Controla condensación, mejora acústica (STC) y reflectancia de luz. Para techos y paredes de edificios metálicos.' },
      alts: ['K-FLEX® Rollo Elastómero']
    },
    'construccion-medio': {
      best: { nombre: 'Metal Building Insulation (MBI)', url: '/collections/fibra-de-vidrio',
        razon: 'Aislamiento térmico y acústico para naves industriales. Fire Hazard ASTM E84 25/50, no combustible ASTM E136, corrosividad ASTM C665. Retardador de vapor integrado. Espesores 3⅜ a 9¼ pulgadas.' },
      alts: ['Placa de Lana Mineral 2", 3" y 4" (semi-rígida, flame spread 0)', 'Colcha de Lana Mineral 144 kg/m³']
    },
    'construccion-alto': {
      best: { nombre: 'Colcha de Lana Mineral 144 kg/m³', url: '/collections/lana-mineral',
        razon: 'Para paredes y ductos industriales a alta temperatura. Hasta 750 °C, ASTM C592 y NRF-034-PEMEX. Espesores de 25 a 101 mm disponibles. Sin asbesto, sin bacterias.' },
      alts: ['FireMaster® FastWrap® XL (protección contra fuego)']
    },
    'construccion-muy-alto': {
      best: { nombre: 'Fibra Cerámica HPS 1200', url: '/collections/fibra-ceramica-hornos',
        razon: 'Revestimiento refractario para estructuras industriales a más de 650 °C. Uso continuo hasta 1200 °C. Aplicaciones típicas: refinación, petroquímica e industria siderúrgica.' },
      alts: ['Fibra Cerámica HTZ 1400', 'FireMaster® FastWrap® XL']
    },

    /* ── ALIMENTO / FARMACÉUTICA ── */
    'alimento-frio': {
      best: { nombre: 'Poliisocianurato ISO-C1', url: '/collections/elastomero-aislamiento-tuberias-armaflex',
        razon: 'Rango -183 °C a +149 °C, factor R 5.7, densidad 2 lb/ft³, cero-ODP. Absorción de agua 0.04 %, celda cerrada >95 %. Ideal para cámaras frías, agua helada, amoníaco y criogénico en plantas de alimentos.' },
      alts: ['K-FLEX® INSUL-TUBO (antimicrobiano EPA, anti-condensación)']
    },
    'alimento-medio': {
      best: { nombre: 'Preformado de Lana Mineral', url: '/collections/lana-mineral',
        razon: 'Incombustible (ASTM E136), resistente al moho (ASTM C1338), no corrosivo (ASTM C795/C692), químicamente inerte, sin asbesto. Sorción de vapor <1 % (ASTM C1104). Para vapor CIP/SIP y equipos farmacéuticos.' },
      alts: ['Colcha de Lana Mineral 144 kg/m³']
    },
    'alimento-alto': {
      best: { nombre: 'Colcha de Lana Mineral 144 kg/m³', url: '/collections/lana-mineral',
        razon: 'Sin asbesto, sin bacterias, sin moho (ASTM C1338), sin olor irritante (ASTM C665-06). Hasta 750 °C. Para autoclaves, pasteurizadores y hornos en industria alimentaria y farmacéutica.' },
      alts: ['Fibra Cerámica HPS 1200 (para temperaturas sobre 750 °C)']
    },
    'alimento-muy-alto': {
      best: { nombre: 'Fibra Cerámica HTZ 1400', url: '/collections/fibra-ceramica-hornos',
        razon: 'Sin aglutinante, sin amianto, sin humos contaminantes. Hasta 1425 °C. Para esterilizadores y hornos farmacéuticos de alta pureza. No desprende fibras ni genera atmósfera contaminante.' },
      alts: ['Fibra Cerámica HPS 1200']
    },

    /* ── ACÚSTICO / VIBRACIÓN (sin temperatura) ── */
    'acustico': {
      best: { nombre: 'Placa de Lana Mineral 2", 3" y 4"', url: '/collections/aislamiento-acustico',
        razon: 'Semi-rígida con excelente rendimiento acústico y térmico simultáneo. Flame spread = 0, smoke = 0 (ASTM E84). Densidades 4–12 pcf para distintas frecuencias. Cumple ASTM C553 Tipo VII, ASTM C612, NOM-009-ENER-2014, NRF-PEMEX-034.' },
      alts: ['Colcha de Lana Mineral 144 kg/m³ (flexible)', 'Metal Building Insulation MBI']
    },

    /* ── FUEGO / INCENDIOS ── */
    'fuego-frio': {
      best: { nombre: 'FireMaster® FastWrap® XL', url: '/products/colcha-firemaster-fastwrap-l-300x48x1-1-2-6-foil-2',
        razon: 'Listada UL/ULC para 1, 2 y 3 horas de protección resistente al fuego (ASTM E2336, ISO 6944). Flame spread < 25, smoke < 50 (ASTM E84). Para ductos de cocina, HVAC y protección estructural a bajas temperaturas.' },
      alts: ['Aislamiento Reusable — Chaqueta Desmontable']
    },
    'fuego-medio': {
      best: { nombre: 'Aislamiento Reusable — Chaqueta Desmontable', url: '/collections/telas-aislamiento-reusable',
        razon: 'Norma ET-034-PEMEX-2019, ASTM C1695-10-2015. Instalación y retiro sin pérdida de material. Para válvulas, bombas, bridas, codos y tuberías hasta 400 °C (Sílice Aluminizada). Sistema VELCRO de sujeción rápida.' },
      alts: ['FireMaster® FastWrap® XL', 'Colcha de Lana Mineral 144 kg/m³']
    },
    'fuego-alto': {
      best: { nombre: 'Aislamiento Reusable — Chaqueta Desmontable', url: '/collections/telas-aislamiento-reusable',
        razon: 'Hasta 1,000 °C estándar (Cerámica/Sílice). Costuras en hilos de sílice/cerámica/cuarzo, resistente a hidrocarburos, aceites y humedad. Cumple ET-034-PEMEX-2019. Para turbinas, filtros bridados y equipos de proceso.' },
      alts: ['Fibra Cerámica HPS 1200', 'Colcha de Lana Mineral 144 kg/m³']
    },
    'fuego-muy-alto': {
      best: { nombre: 'Aislamiento Reusable Especial (Sílice + Inconel)', url: '/collections/telas-aislamiento-reusable',
        razon: 'Configuración especial con malla Inconel (1,093 °C continuo) hasta 1,400 °C. Para turbinas, múltiples de escape, puntas rotatorias y equipos de alta temperatura con mantenimiento frecuente.' },
      alts: ['Fibra Cerámica HTZ 1400 (hasta 1,425 °C)']
    },

    default: {
      best: { nombre: 'Preformado de Lana Mineral', url: '/collections/lana-mineral',
        razon: 'El material de aislamiento más versátil de Conscomer. Rango -29 °C a 649 °C, ASTM C547 Tipo I/II/IV Grado A, NOM-009-ENER-2014. Disponible en todos los diámetros NPS.' },
      alts: ['Fibra Cerámica HPS 1200', 'K-FLEX® INSUL-TUBO']
    }
  };

  function getRec(ans) {
    if (ans.aplicacion === 'acustico') return RECS['acustico'] || RECS.default;
    var k = [ans.aplicacion, ans.temperatura].join('-');
    return RECS[k] || RECS.default;
  }

  /* ------------------------------------------------------------------
     Utilidades
     ------------------------------------------------------------------ */

  var uid = 0;

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function findOption(stepId, value) {
    for (var i = 0; i < TREE.length; i++) {
      if (TREE[i].id !== stepId) continue;
      var ops = TREE[i].opciones;
      for (var j = 0; j < ops.length; j++) {
        if (ops[j].val === value) return ops[j];
      }
    }
    return null;
  }

  /* ------------------------------------------------------------------
     Instancia del componente
     ------------------------------------------------------------------ */

  function createSelector(container) {
    if (container.dataset.conscomerReady === 'true') return;
    container.dataset.conscomerReady = 'true';

    uid += 1;
    var instanceId = 'conscomer-selector-' + uid;

    var answers = {};
    var stepIndex = 0;

    var contactUrl = container.dataset.contactUrl || '/pages/contacto';
    var showNotice = container.dataset.showNotice !== 'false';
    var noticeText = container.dataset.notice ||
      'Esta recomendación es orientativa. Para proyectos con condiciones especiales, solicita asesoría técnica antes de realizar tu compra.';

    /* Pasos aplicables según las respuestas actuales */
    function flow() {
      if (answers.aplicacion === 'acustico') return [TREE[0]];
      return TREE;
    }

    function clear() {
      while (container.firstChild) container.removeChild(container.firstChild);
    }

    function buildProgress(current, total, complete) {
      var wrap = el('div', 'conscomer-selector__progress');

      var track = el('div', 'conscomer-selector__progress-track');
      track.setAttribute('role', 'progressbar');
      track.setAttribute('aria-valuemin', '0');
      track.setAttribute('aria-valuemax', '100');

      var pct = complete ? 100 : Math.round(((current - 1) / total) * 100);
      track.setAttribute('aria-valuenow', String(pct));
      track.setAttribute('aria-label', 'Avance del selector');

      var bar = el('span', 'conscomer-selector__progress-bar');
      bar.style.width = pct + '%';
      track.appendChild(bar);

      var label = el(
        'p',
        'conscomer-selector__progress-label',
        complete ? 'Resultado' : 'Paso ' + current + ' de ' + total
      );

      wrap.appendChild(track);
      wrap.appendChild(label);
      return wrap;
    }

    /* ---------------- Vista de pregunta ---------------- */

    function renderStep(focusHeading) {
      var steps = flow();
      if (stepIndex > steps.length - 1) stepIndex = steps.length - 1;
      if (stepIndex < 0) stepIndex = 0;

      var node = steps[stepIndex];
      clear();

      container.appendChild(buildProgress(stepIndex + 1, steps.length, false));

      var panel = el('div', 'conscomer-selector__panel');
      var group = el('div');
      group.setAttribute('role', 'group');

      var headingId = instanceId + '-q-' + node.id;
      var heading = el('h3', 'conscomer-selector__question', node.pregunta);
      heading.id = headingId;
      heading.setAttribute('tabindex', '-1');
      group.setAttribute('aria-labelledby', headingId);
      group.appendChild(heading);

      var list = el('div', 'conscomer-selector__options' +
        (node.compacto ? ' conscomer-selector__options--compact' : ''));

      var buttons = [];

      node.opciones.forEach(function (opcion) {
        var btn = el('button', 'conscomer-selector__option');
        btn.type = 'button';
        btn.setAttribute('aria-pressed', answers[node.id] === opcion.val ? 'true' : 'false');

        var iconWrap = el('span', 'conscomer-selector__option-icon');
        iconWrap.setAttribute('aria-hidden', 'true');
        iconWrap.appendChild(buildIcon(opcion.icon));

        var body = el('span', 'conscomer-selector__option-body');
        body.appendChild(el('span', 'conscomer-selector__option-label', opcion.label));
        if (opcion.sub) {
          body.appendChild(el('span', 'conscomer-selector__option-note', opcion.sub));
        }

        var mark = el('span', 'conscomer-selector__option-mark');
        mark.setAttribute('aria-hidden', 'true');
        mark.appendChild(buildIcon('check'));

        btn.appendChild(iconWrap);
        btn.appendChild(body);
        btn.appendChild(mark);

        btn.addEventListener('click', function () {
          var previousApp = answers.aplicacion;

          answers[node.id] = opcion.val;

          /* Si cambia la aplicación, la temperatura anterior deja de ser válida */
          if (node.id === 'aplicacion' && previousApp !== opcion.val) {
            delete answers.temperatura;
          }

          buttons.forEach(function (other) {
            other.setAttribute('aria-pressed', other === btn ? 'true' : 'false');
          });

          validation.hidden = true;
          validation.textContent = '';
          updateNext();
        });

        buttons.push(btn);
        list.appendChild(btn);
      });

      group.appendChild(list);
      panel.appendChild(group);

      var validation = el('p', 'conscomer-selector__validation');
      validation.id = instanceId + '-validacion';
      validation.setAttribute('role', 'alert');
      validation.hidden = true;
      panel.appendChild(validation);

      var nav = el('div', 'conscomer-selector__nav');

      var back = el('button', 'conscomer-selector__action conscomer-selector__action--secondary', 'Regresar');
      back.type = 'button';
      if (stepIndex === 0) {
        back.disabled = true;
      }
      back.addEventListener('click', function () {
        if (stepIndex === 0) return;
        stepIndex -= 1;
        renderStep(true);
      });

      var next = el('button', 'conscomer-selector__action conscomer-selector__action--primary', 'Continuar');
      next.type = 'button';
      next.setAttribute('aria-describedby', validation.id);

      function isLastStep() {
        return stepIndex >= flow().length - 1;
      }

      function updateNext() {
        var answered = Boolean(answers[node.id]);
        next.textContent = isLastStep() ? 'Ver recomendación' : 'Continuar';
        next.setAttribute('aria-disabled', answered ? 'false' : 'true');
      }

      next.addEventListener('click', function () {
        if (!answers[node.id]) {
          validation.textContent = 'Selecciona una opción para continuar.';
          validation.hidden = false;
          if (buttons.length) buttons[0].focus();
          return;
        }
        if (isLastStep()) {
          renderResult();
          return;
        }
        stepIndex += 1;
        renderStep(true);
      });

      updateNext();

      nav.appendChild(back);
      nav.appendChild(next);
      panel.appendChild(nav);
      container.appendChild(panel);

      if (focusHeading) heading.focus();
    }

    /* ---------------- Vista de resultado ---------------- */

    function renderResult() {
      var rec = getRec(answers);
      clear();

      var steps = flow();
      container.appendChild(buildProgress(steps.length, steps.length, true));

      var panel = el('div', 'conscomer-selector__panel');

      /* Resumen de respuestas */
      var summary = el('div', 'conscomer-selector__result-summary');
      TREE.forEach(function (step) {
        var value = answers[step.id];
        if (!value) return;
        var opcion = findOption(step.id, value);
        if (!opcion) return;
        var item = el('span');
        item.appendChild(el('strong', null, step.resumen + ': '));
        item.appendChild(document.createTextNode(opcion.label));
        summary.appendChild(item);
      });
      if (summary.childNodes.length) panel.appendChild(summary);

      var title = el('h3', 'conscomer-selector__result-title', 'Recomendación para tu aplicación');
      title.setAttribute('tabindex', '-1');
      panel.appendChild(title);

      /* Producto sugerido */
      var product = el('div', 'conscomer-selector__product');
      product.appendChild(el('span', 'conscomer-selector__label', 'Opción sugerida'));
      product.appendChild(el('h4', 'conscomer-selector__product-name', rec.best.nombre));
      product.appendChild(el('p', 'conscomer-selector__product-reason', rec.best.razon));

      var link = el('a', 'conscomer-selector__action conscomer-selector__action--primary', 'Ver productos');
      link.setAttribute('href', rec.best.url);
      product.appendChild(link);
      panel.appendChild(product);

      /* Alternativas */
      if (rec.alts && rec.alts.length) {
        var alts = el('div', 'conscomer-selector__alts');
        alts.appendChild(el('span', 'conscomer-selector__label', 'También puedes considerar'));
        var ul = el('ul', 'conscomer-selector__alts-list');
        rec.alts.forEach(function (texto) {
          ul.appendChild(el('li', null, texto));
        });
        alts.appendChild(ul);
        panel.appendChild(alts);
      }

      /* Aviso técnico */
      if (showNotice && noticeText) {
        panel.appendChild(el('p', 'conscomer-selector__notice', noticeText));
      }

      /* Acciones */
      var actions = el('div', 'conscomer-selector__result-actions');

      var asesoria = el('a', 'conscomer-selector__action conscomer-selector__action--secondary', 'Solicitar asesoría técnica');
      var params = [];
      if (answers.aplicacion) params.push('aplicacion=' + encodeURIComponent(answers.aplicacion));
      if (answers.temperatura) params.push('temperatura=' + encodeURIComponent(answers.temperatura));
      if (rec.best && rec.best.nombre) params.push('producto=' + encodeURIComponent(rec.best.nombre));
      var sep = contactUrl.indexOf('?') === -1 ? '?' : '&';
      asesoria.setAttribute('href', params.length ? contactUrl + sep + params.join('&') : contactUrl);

      var restart = el('button', 'conscomer-selector__action conscomer-selector__action--quiet', 'Comenzar de nuevo');
      restart.type = 'button';
      restart.addEventListener('click', function () {
        Object.keys(answers).forEach(function (k) { delete answers[k]; });
        stepIndex = 0;
        renderStep(true);
      });

      actions.appendChild(asesoria);
      actions.appendChild(restart);
      panel.appendChild(actions);

      container.appendChild(panel);
      title.focus();
    }

    renderStep(false);
  }

  /* ------------------------------------------------------------------
     Arranque
     ------------------------------------------------------------------ */

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var nodes = root.querySelectorAll('[data-conscomer-selector]');
    if (!nodes.length) return;
    Array.prototype.forEach.call(nodes, createSelector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Recarga dentro del editor de temas de Shopify */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();